/* hand-written — kept alongside generated services */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type PreseasonGameInvitationTermSnapshotDto = {
    invitationTermId: number;
    termId: number | null;
    startDate: string;
    endDate: string;
};

export type PreseasonGameInvitationSummaryDto = {
    id: number;
    token: string;
    shareUrl: string;
    teamId: number;
    teamName: string;
    active: boolean;
    createdAt: string;
    expiresAt: string | null;
    responseCount: number;
    terms: Array<PreseasonGameInvitationTermSnapshotDto>;
};

export type TermAvailabilityStatus = 'AVAILABLE' | 'UNAVAILABLE_DELETED' | 'UNAVAILABLE_QUOTA_FULL';

export type PreseasonGameInvitationPublicTermDto = {
    invitationTermId: number;
    startDate: string;
    endDate: string;
    availability: TermAvailabilityStatus;
};

export type PreseasonGameInvitationPublicDto = {
    token: string;
    active: boolean;
    teamName: string;
    teamTier: string | null;
    sportsClubName: string | null;
    sportsClubCity: string | null;
    logoUrl: string | null;
    terms: Array<PreseasonGameInvitationPublicTermDto>;
};

export type CreatePreseasonGameInvitationDto = {
    teamId: number;
    termIds: Array<number>;
};

export type RespondToPreseasonGameInvitationDto = {
    respondingTeamId: number;
    selectedInvitationTermIds: Array<number>;
    message?: string;
};

export type PreseasonGameInvitationResponseResultDto = {
    createdPreseasonGameIds: Array<number>;
    createdCount: number;
};

export class PreseasonGameInvitationControllerService {

    public static createInvitation(
        requestBody: CreatePreseasonGameInvitationDto,
    ): CancelablePromise<PreseasonGameInvitationSummaryDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-game-invitations',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    public static listOwn(): CancelablePromise<Array<PreseasonGameInvitationSummaryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-game-invitations',
        });
    }

    public static deactivate(token: string): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-game-invitations/{token}/deactivate',
            path: { 'token': token },
        });
    }

    public static deleteInvitation(token: string): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/preseason-game-invitations/{token}',
            path: { 'token': token },
        });
    }

    public static getPublic(token: string): CancelablePromise<PreseasonGameInvitationPublicDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-game-invitations/public/{token}',
            path: { 'token': token },
        });
    }

    public static respond(
        token: string,
        requestBody: RespondToPreseasonGameInvitationDto,
    ): CancelablePromise<PreseasonGameInvitationResponseResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-game-invitations/{token}/respond',
            path: { 'token': token },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
